import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PresetState {
    selectedStation: any | null;
}

const initialState: PresetState = {
    selectedStation: null,
};

const presetSlice = createSlice({
    name: "preset",
    initialState,
    reducers: {
        setPresetStation: (state, action: PayloadAction<any>) => {
            state.selectedStation = action.payload;
        },
        clearPresetStation: (state) => {
            state.selectedStation = null;
        },
    },
});

export const { setPresetStation, clearPresetStation } = presetSlice.actions;
export default presetSlice.reducer;
